import {useDeviceState} from '../../responsive/hooks/useDeviceState';
import {APP_NAME, APP_NAME_SHORT} from '../constants';

export function useResponsiveAppName(): string {
  const {isNarrow} = useDeviceState();
  return isNarrow ? APP_NAME_SHORT : APP_NAME;
}
